<template>
    <div>
        <div class="app-container">
            <div style="height: 30px">
                <div style="float: right; color: #848484; display: flex; line-height: 28px">
                    <div v-if="!showdiv">
                        <a-input v-model="queryCondition.materialCode" placeholder="物料号" clearable
                            style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
                        <a-input v-model="queryCondition.materialName" placeholder="物料名称" clearable
                            style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
                    </div>
                    <div>
                        <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
                        <vxe-button v-if="!showdiv" class="filter-search-item" @click="resetForm">重置</vxe-button>
                        <vxe-button type="warning" @click="cb">
                            {{ showdiv ? '收起' : '更多选项' }}
                        </vxe-button>
                    </div>
                </div>
            </div>
            <!--筛选拓展-->
            <div style="margin-top: 10px">
                <a-collapse>
                    <div v-if="showdiv">
                        <div v-if="showdiv">
                            <SiftMaterial :data.sync="queryCondition" :type="siftType" :list="SelectLists" />
                            <br>
                            <div slot="footer" style="text-align: center; padding-bottom: 10px">
                                <vxe-button @click="resetForm">重置</vxe-button>
                                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
                            </div>
                        </div>
                    </div>
                </a-collapse>
            </div>
            <!--table列表-->
            <vxe-table ref="xTable" v-loading="listLoading" :align="allAlign"
                :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130" border
                show-header-overflow show-overflow class="mytable-scrollbar" :column-config="{ resizable: true }" stripe
                round :scroll-y="{ enabled: false }" :row-config="{ isHover: true }" :data="tableData"
                @sort-change="listSortMethod">
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column field="materialCode" title="物料号" width="150" />
                <vxe-column field="materialName" title="物料名称" width="300" />
                <vxe-column field="materialType" title="物料类型" width="100">
                    <template #default="{ row }">
                        {{ row.materialType }}
                    </template>
                </vxe-column>
                <vxe-column field="storage" title="库存" width="100" sortable/>
                <vxe-column field="price" title="申领价（元）" width="120" sortable>
                    <template #default="{ row }">
                        {{ row.price | toThousandNumFilter }}
                    </template>
                </vxe-column>
                <vxe-column field="unit" title="单位" width="100" />
                <vxe-column field="remark" title="备注"/>
                <vxe-column title="操作" width="80" fixed="right" align="center" >
                    <template #default="{ row }">
                        <div class="operate">
                        <a-button size="small" type="link" @click="picInfo(row)">查看图片</a-button>
                        </div>
                    </template>
                </vxe-column>
            </vxe-table>
            <vxe-pager
                :current-page="pagination.current"
                :page-size="pagination.size"
                :total="pagination.total"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                @page-change="changePage"
            />
            <!-- 看图弹框 -->
            <a-modal
                v-model="isModalVisible"
                title="查看图片"
                width="800px"                
                @cancel="handleCancel"
                cancelText="关闭"
                :destrayOnClose="true"
            >
            <template slot="footer" >
                    <a-button  @click="handleCancel">关闭</a-button>
            </template>
                <a-form>
                    <a-row>
                        <a-col>
                            <a-form-item>
                            <div v-if="picList != null">
                                <div v-for=" (pic, index) in picList " :key="index" class="pic-box">
                                <el-image
                                    style="width: 150px; height: 150px"
                                    :src="pic"
                                    :preview-src-list="picList"
                                    fit="cover"
                                />
                                </div>
                            </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-modal>
        </div>
    </div>
</template>

<script>
import { materialfindList, getMaterialById, getImgs } from '@/api/material'
import { setInitImg } from '@/utils/Picture/transferFile'
import SiftMaterial from './components/SiftMaterial.vue'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
    name: 'PublicizeMaterialQuery',
    components: {SiftMaterial},
    data(){
        return {
            showdiv: false,
            pagination: Object.assign({}, defaultPagination),
            listLoading: false,
            tableData: [],
            allAlign: 'center',
            queryCondition: {storage: '1',isApply: '1'},
            // 导出对话框
            dialogVisible: false,
            disabled: true, // 已选择按钮是否禁用
            outExcelButtonLocading: false,
            ExportItem: 0,
            fileList: [],
            errorList: [],
            uploadDialog: false,
            importLoading: false,
            SelectLists: {},
            sort: 'creater_date desc',
            isModalVisible: false,
            picList: [],
            fileNames: [],
            // 筛选条件框类型 0物料维护，1入库，2出库
            siftType: 0
        }
    },
    watch: {},
    activated() {
        console.log('activated')
        this.queryByPage()
    },
    created(){
        // 获取表格数据
        this.queryByPage()
        // 获取下拉框列表
        this.SelectListFun()
    },
    mounted(){},
    methods:{
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
        // 重置筛选
        resetForm() {
      this.queryCondition = {storage: '1',isApply: '1'}
      this.queryByPage(1)
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].property + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
        // 获取下拉列表
        SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    },
       // 查询表格数据
       async queryByPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort
      }
      this.listLoading = true // 开启加载动画
      materialfindList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
        picInfo(row) {
            //   this.$router.push({ path: `detailMaterial/${row.materialId}` })
            console.log("row:", row);
            getMaterialById(row.materialId).then(res => {
                if (res.code === 1) {
                    //   this.material = res.data.material
                    if (res.data.fileNames.length > 0) {
                        this.fileNames = res.data.fileNames
                        this.fileNames.forEach(name => {
                            const data = {
                                fileName: name,
                                materialCode: row.materialCode
                            }
                            getImgs(data).then(res => {
                                const file = setInitImg(res, name)
                                this.picList.push(file.url)
                            })
                        })
                    }
                }
            })
            this.isModalVisible = true
        },
        handleCancel(){
            this.isModalVisible = false
            this.picList = []
        }
    }
}
</script>

<style lang="less">
.a-input--medium .a-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.el-link {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  // float: right;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
</style>